import { create } from 'zustand';

import type { VersionNoteState } from '@/screens/VersionNote/versionNote.types';

type VersionNoteStore = {
  state: VersionNoteState | null;
  setState: (nextState: VersionNoteState | null) => void;
  clear: () => void;
};

export const useVersionNoteStore = create<VersionNoteStore>((set) => ({
  state: null,
  setState: (nextState): void => {
    set({ state: nextState });
  },
  clear: (): void => {
    set({ state: null });
  },
}));
